import { logger as LOG } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────
// LOG.enable('REFRESH API ACCESS TOKENS');
export const logger = LOG.extend('REFRESH API ACCESS TOKENS');
